import * as Dialogues from './Dialogues';
import * as Properties from './Properties';
import * as Relations from './Relations';

export class Directory {
    descriptors: {
        dialogues: Map<string, Dialogues.Descriptor>;
        properties: Map<string, Properties.Descriptor<any>>;
        relations: Map<string, Relations.Descriptor<any>>;
    };

    static from(...children: Directory[]) {
        const result = new Directory();
        for(let child of children) {
            for(let [key, value] of child.descriptors.dialogues) {
                result.descriptors.dialogues.set(key, value);
            }
            for(let [key, value] of child.descriptors.properties) {
                result.descriptors.properties.set(key, value);
            }
            for(let [key, value] of child.descriptors.relations) {
                result.descriptors.relations.set(key, value);
            }
        }
        return result;
    }
    constructor() {
        this.descriptors = {
            dialogues: new Map(),
            properties: new Map(),
            relations: new Map()
        }
    }
    loadFactories() {
        for(let [key, descriptor] of this.descriptors.properties) {
            Properties.Descriptor.Directory.resolve(key, descriptor);
        }
        for(let [key, descriptor] of this.descriptors.relations) {
            Relations.Descriptor.Directory.resolve(key, descriptor);
        }
    }    
}
